// Feature-access predicates shared by server checks and client code. Kept
// free of `server-only` on purpose: the rule a route handler enforces must be
// the same rule the UI uses to decide what to render.
import { isAdminEmail } from "./admin";
import { isPaidPlan, type UserPlan } from "./plans";

/**
 * Paid features (Pro and up): a paid plan OR an admin email. This is the
 * "admin OR paid" rule the UI gates already apply (LazyNewTrendingBlock,
 * ReviewInsightsButton, the review-insights page).
 */
export function hasPaidAccess(
  plan: UserPlan,
  email: string | null | undefined,
): boolean {
  return isPaidPlan(plan) || isAdminEmail(email);
}

/**
 * Studio-only features (audience scans): the studio plan OR an admin email —
 * the rule every audience server action applies.
 */
export function hasStudioAccess(
  plan: UserPlan,
  email: string | null | undefined,
): boolean {
  return plan === "studio" || isAdminEmail(email);
}

/**
 * API access (minting keys, the /api/v1 REST API, the hosted MCP server) is
 * part of Studio: the studio plan OR an admin email. The same rule decides
 * whether a key works on every request, so a key stops working the moment its
 * owner's plan lapses.
 */
export function hasApiAccess(
  plan: UserPlan,
  email: string | null | undefined,
): boolean {
  return plan === "studio" || isAdminEmail(email);
}
